module.exports = __webpack_public_path__ + "static/img/LOGO.3b6ce44c.png";